import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'lrnr-orientation',
	template: `
		<iframe
			src="https://scribehow.com/page-embed/LanguageBird_Learner_Orientation__ZNjUWuTeSS679x2AVXnjkw"
			width="100%"
			allowfullscreen="true"
			style="border: 0; height: calc(100vh - 160px)"
		></iframe>
	`
})
export class OrientationComponent {}
